import { createPrismicAuthManager } from "../auth/createPrismicAuthManager.js";
import { API_ENDPOINTS } from "../constants/API_ENDPOINTS.js";
import { CustomTypesManager } from "./customTypes/CustomTypesManager.js";
import { PluginsManager } from "./plugins/PluginsManager.js";
import { PrismicRepositoryManager } from "./prismicRepository/PrismicRepositoryManager.js";
import { ProjectManager } from "./project/ProjectManager.js";
import { SlicesManager } from "./slices/SlicesManager.js";
import { TelemetryManager } from "./telemetry/TelemetryManager.js";
import { UserManager } from "./user/UserManager.js";
import { VersionsManager } from "./versions/VersionsManager.js";
class PrismicManager {
  _pluginSystemRunner = void 0;
  _prismicAuthManager;
  cwd;
  customTypes;
  plugins;
  prismicRepository;
  project;
  slices;
  telemetry;
  user;
  versions;
  constructor(args) {
    this._prismicAuthManager = createPrismicAuthManager();
    this.user = new UserManager(this);
    this.prismicRepository = new PrismicRepositoryManager(this);
    this.plugins = new PluginsManager(this, {
      nativePlugins: args?.nativePlugins
    });
    this.project = new ProjectManager(this);
    this.customTypes = new CustomTypesManager(this);
    this.slices = new SlicesManager(this);
    this.versions = new VersionsManager(this);
    this.telemetry = new TelemetryManager(this);
    this.cwd = args?.cwd ?? process.cwd();
  }
  // The `_pluginSystemRunner` property is hidden behind a function to
  // discourage access. Using a function deliberately breaks the pattern
  // of other child managers that are accessible as properties, like
  // `project`, `plugins`, etc. We do not treat PluginSystemRunner
  // as a child manager.
  getPluginSystemRunner() {
    return this._pluginSystemRunner;
  }
  // The `_prismicAuthManager` property is hidden behind a function to
  // discourage access. Using a function deliberately breaks the pattern
  // of other child managers that are accessible as properties, like
  // `project`, `plugins`, etc. We do not treat PrismicAuthManager as a
  // child manager.
  getPrismicAuthManager() {
    return this._prismicAuthManager;
  }
  getAPIEndpoints() {
    return API_ENDPOINTS;
  }
}
export {
  PrismicManager
};
//# sourceMappingURL=PrismicManager.js.map
